'use strict';

var SessionStorageStateSource = require('./sessionStorage');
var registerStateSource = require('../core/registerStateSource');

module.exports = function (marty) {
  registerStateSource(marty, 'SessionStorageStateSource', 'sessionStorage', SessionStorageStateSource);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/session-storage-state-source/index.js
// module id = T//J
// module chunks = 88